<template>
  <div class="home" ref="homeRef">
    <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" title="东方智汇"></Header>

    <div v-if="$route.path === '/home'" class="content" ref="contentRef">
      <cube-scroll ref="scrollRef" :options="scrollOptions" @pulling-down="onPullingDown">
        <Swiper ref="swiperRef"></Swiper>
        <Tablist ref="tabRef"></Tablist>
        <course-list-wrapper title="课程学习" to="/course" mini-path="/pages/learn/course/course" :courses="courseList"></course-list-wrapper>
      </cube-scroll>
    </div>

    <router-view />
  </div>
</template>

<script>
import Header from '../../components/Header'
import Swiper from '../index/Swiper'
import Tablist from '../index/Tablist'
import CourseListWrapper from '../../components/CourseListWrapper'
import { queryCourseList } from '@/api/course'
export default {
  name: 'Home',
  components: { CourseListWrapper, Swiper, Tablist, Header },
  data () {
    return {
      courseList: [],
      scrollOptions: {
        pullDownRefresh: {
          txt: '刷新成功'
        }
      },
      isFirst: true
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }

    if (this.$refs.contentRef) {
      this.$nextTick(() => {
        const navBarHeight = this.$refs.navBarRef ? this.$refs.navBarRef.$el.clientHeight : 0
        this.$refs.contentRef.style.height = (this.$refs.homeRef.clientHeight - navBarHeight) + 'px'
      })
    }

    if (this.isFirst) {
      this.isFirst = false
      this.getCourseData()
    }
  },
  methods: {
    onPullingDown () {
      this.getCourseData()

      setTimeout(() => {
        console.log('更新数据。。。')
        this.$refs.scrollRef.forceUpdate()
      }, 1000)
    },
    // 获取课程数据
    getCourseData () {
      if (this.$route.path !== '/home') return

      if (!this.$store.state.token.token) {
        // error
        setTimeout(() => {
          console.log('index getCourseData  go logout')
          this.$dfzhJsBridge.goLogout()
        }, 1000)
        return
      }

      queryCourseList({
        page: 1,
        size: 3
      })
        .then((res) => {
          console.log('data:', res.data)
          console.log('records len=' + res.data.records.length)
          const records = res.data.records
          // fixme 排序
          records.sort(this.compare('sort'))
          this.courseList.splice(0)
          records.forEach((item, idx) => {
            const course = {
              id: item.courseId,
              title: item.name,
              url: item.cover.resUrl,
              read: item.readNum,
              comment: item.commentNum,
              type: item.typeCode,
              medias: item.medias
            }
            this.courseList.push(course)
          })
        })
        .catch(e => {
          console.error(e.message)
        })
    },
    compare (attr) {
      return function (a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val1 - val2
      }
    }

  }
}
</script>

<style lang="stylus">
body
  background-color #f7f7f7 !important
</style>

<style lang="stylus" scoped>
.home
  height 100%
</style>
